const Rodape = () => {
  return (
    <footer>
        <p>© 2023 Olival Paulino, Dev. </p>
    </footer>
  )
}

export default Rodape